import styled from 'styled-components'
import { Spin } from 'antd'

export const StyledLoader = styled(Spin)`
  width: 100%;
  line-height: 20 !important;
  & .anticon {
    font-size: 250% !important;
  }
`



// WEBPACK FOOTER //
// ./src/components/Loader/styled.js